module.exports = __webpack_public_path__ + "static/media/18-AccountingForOurselves.d5511378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/18-AccountingForOurselves.jpg
// module id = 152
// module chunks = 0